import { Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-vehicle-changed-warning',
    templateUrl: './vehicle-changed-warning.component.html',
    imports: [TranslocoDirective]
})
export class VehicleChangedWarningComponent {}
